module.exports = __webpack_public_path__ + "img/certify.5704bb72.png";